import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Section2 = ({ style }) => {
  const [showVideo, setShowVideo] = useState(false);
  
  const handlePlayClick = () => {
    setShowVideo(true);
  };
  
  return (
    <section className="section-2" style={style}>
      <div className="container">
        <div className="section-2-title-container">
          <h2 className="section-2-title">
            Make Your Poster in 2 Easy Steps
          </h2>
        </div>
        
        <div className="video-container">
          {!showVideo ? (
            <div className="video-thumbnail-overlay" style={{ 
              backgroundImage: "url('/youtubethumbnail verlay.png')", 
              backgroundSize: "cover", 
              backgroundPosition: "center" 
            }}>
              <button 
                className="video-play-button" 
                onClick={handlePlayClick}
                aria-label="Play video"
              >
                <div className="play-icon"></div>
              </button>
            </div>
          ) : (
            <iframe
              src="https://www.youtube.com/embed/5fg5k3sFHIc?autoplay=1"
              title="Make Your Poster in 2 Easy Steps"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="youtube-video"
              loading="lazy"
            ></iframe>
          )}
        </div>
        
        <div className="start-button-container">
          <Link 
            to="/otp-verification" 
            className="btn-neo start-btn" 
            style={{ fontSize: '1.5em', padding: '15px 30px', fontWeight: 'bold' }}
          >
            Start Creating <span>&gt;</span>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Section2; 